import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { blogPosts } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  useSeo({
    title: "Risorse & Blog — normativa e investimenti immobiliari",
    description:
      "Approfondimenti su normativa e mercato immobiliare: Riforma Cartabia, CIN affitti brevi, cedolare secca studenti, club deal. Le risorse di Opera Real Estate Partners.",
  });

  return (
    <div>
      <section className="bg-[#0D1B2A] pt-20 pb-14 border-b border-white/5 relative noise-overlay">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 relative z-10">
          <span className="label-eyebrow">Risorse & Blog</span>
          <Reveal>
            <h1 className="font-display font-light text-4xl lg:text-6xl text-white mt-4 max-w-3xl leading-tight">
              Capire prima di investire
            </h1>
          </Reveal>
          <p className="text-gray-400 mt-6 max-w-2xl leading-relaxed">
            Contenuti chiari su normativa e mercato, a supporto di decisioni consapevoli.
          </p>
        </div>
      </section>

      <section className="bg-[#1E2229] py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-3 gap-px bg-white/5">
            {blogPosts.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group block bg-[#0D1B2A] p-8 h-full hover:bg-white/[0.03] transition-colors"
                >
                  <div className="flex items-center justify-between">
                    <span className="label-eyebrow">{p.category}</span>
                    <span className="text-xs text-gray-500">{p.date}</span>
                  </div>
                  <h2 className="font-display text-xl text-white mt-5 leading-snug">{p.title}</h2>
                  <p className="text-sm text-gray-400 mt-4 leading-relaxed">{p.excerpt}</p>
                  <span className="inline-flex items-center gap-1 text-[#C5A059] text-sm mt-6 group-hover:gap-2 transition-all">
                    Leggi <ArrowUpRight size={15} />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
